//SI GESTION CHEF DE SERVICE A LA CREATION

$(document).ready(function () {
    $('#status_id').on('change', toggleStatutOption);
    if ($('#status_id').val() == 3)
        $('#chief_services').removeAttr('hidden');

    if ($('#status_id').val() == 4)
        $('#logistique_services').removeAttr('hidden');

    if ($('#status_id').val() == 5)
        $('#direction_services').removeAttr('hidden');

    $('[name="js-select_all"]').on('click', toggleServiceChecbox);
});

function toggleStatutOption(e) {
    if (e.target.value == 3){
        $('#direction_services').attr('hidden', true);
        $('#chief_services').removeAttr('hidden');
        $('.logistique_field').prop('required', false);
    }
    else if(e.target.value == 4){
        $('#direction_services').attr('hidden', true);
        $('#chief_services').attr('hidden', true);
        $('#logistique_services').removeAttr('hidden');
        $('.logistique_field').prop('required', true);
    }
    if (e.target.value == 5){
        $('#direction_services').removeAttr('hidden');
        $('#chief_services').attr('hidden', true);
        $('.logistique_field').prop('required', false);
    }
    else{
        if (!($('#chief_services').attr('hidden')))
            $('#chief_services').attr('hidden', true);
        
        if (!($('#logistique_services').attr('hidden')))
            $('#logistique_services').attr('hidden', true);
        
        if (!($('#direction_services').attr('hidden')))
            $('#direction_services').attr('hidden', true);

        $('.logistique_field').prop('required', false);
    }
}

function toggleServiceChecbox(){
    if(this.checked) {
        // Iterate each checkbox
        $('.checkbox-services :checkbox').each(function() {
            this.checked = true;
        });
    } else {
        $('.checkbox-services :checkbox').each(function() {
            this.checked = false;
        });
    }
}